/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import { isDevMode } from '@angular/core';
import { NbPasswordStrategyModule } from '@nebular/auth';
import { firebasePasswordStrategyOptions as fbPassSO } from '@nebular/firebase-auth';
import { withNgxsReduxDevtoolsPlugin } from '@ngxs/devtools-plugin';
import { withNgxsRouterPlugin } from '@ngxs/router-plugin';
import { withNgxsStoragePlugin } from '@ngxs/storage-plugin';
import { name } from '../../project.json';
import { EnvironemntConfig } from './environment.type';
import { FCMState } from '@res/ngg-core';

export const environment: EnvironemntConfig = {
  matOptions: { formField: { appearance: 'outline' }, icon: { fontSet: 'material-symbols-outlined' } },
  routerConfigOptions: { paramsInheritanceStrategy: 'always' },
  production: false,
  version: 'development',
  serviceName: name,
  currentThemeLife: 604800000,
  firebaseConfig: {
    apiKey: 'AIzaSyBcgTq61Tse276hJhYoppAbWZR70KqX8nM',
    authDomain: 'rent-me-a8855.firebaseapp.com',
    projectId: 'rent-me-a8855',
    storageBucket: 'rent-me-a8855.appspot.com',
    messagingSenderId: '738242976811',
    appId: '1:738242976811:web:3e783fffd85c6681659e6e',
    measurementId: 'G-3GKCWY6SQ5',
    vapidKey: 'BIh-myaSoVOK7Dr6ZkpCtEF5YzmB4tCnVf4aekP7McoBy06eE0vyGSuAtC0CAl5PUvtiTkHFzQjY5C5gFuGg1Ps',
  },
  firebaseAppCheckKey: '6Ld_BlEqAAAAAAejkAWOtfn11QTWWMMykA1O5dha',
  transloco: {
    availableLangs: ['en', 'hu'],
    defaultLang: 'hu',
    fallbackLang: 'hu',
    // Remove this option if your application doesn't support changing language in runtime.
    reRenderOnLangChange: true,
    prodMode: !isDevMode(),
  },
  nbChatConfig: { messageGoogleMapKey: 'AIzaSyDPVH8DeaRssueP4mKCoHnicNS34guwETc' },
  coreConfig: {
    authOptions: {
      firebaseStrategieSetup: {
        ...fbPassSO,
        name: 'password',
        login: {
          ...(fbPassSO.login as NbPasswordStrategyModule),
          redirect: {
            success: 'pages',
          },
        },
        register: {
          ...(fbPassSO.register as NbPasswordStrategyModule),
          redirect: {
            success: 'pages',
          },
        },
        logout: {
          ...(fbPassSO.logout as NbPasswordStrategyModule),
          redirect: {
            success: 'auth/login',
          },
        },
        requestPassword: {
          ...(fbPassSO.requestPassword as NbPasswordStrategyModule),
          redirect: {
            success: null,
          },
        },
        resetPassword: {
          ...(fbPassSO.resetPassword as NbPasswordStrategyModule),
          redirect: {
            success: null,
          },
        },
        refreshToken: {
          ...(fbPassSO.refreshToken as NbPasswordStrategyModule),
          redirect: {
            success: '',
          },
        },
      },
      forms: {
        login: {
          strategy: 'password',
          rememberMe: true,
          socialLinks: [],
        },
        register: {
          strategy: 'password',
          terms: true,
          socialLinks: [],
        },
        logout: {
          strategy: 'password',
        },
        requestPassword: {
          strategy: 'password',
          socialLinks: [],
        },
        resetPassword: {
          strategy: 'password',
          socialLinks: [],
        },
        validation: {
          password: {
            required: true,
            minLength: 6,
            maxLength: 50,
          },
          email: {
            required: true,
          },
          fullName: {
            required: false,
            minLength: 4,
            maxLength: 50,
          },
        },
      },
    },
    securityOptions: {
      accessControl: {
        guest: {
          view: '*',
        },
        user: {
          parent: 'guest',
          create: '*',
          edit: '*',
          // remove: '*',
        },
      },
    },
  },
  ngxsPlugins: [
    withNgxsReduxDevtoolsPlugin({ name: 'RentMe-NGXS' }),
    withNgxsRouterPlugin(),
    // withNgxsLoggerPlugin(),
    withNgxsStoragePlugin({ keys: [FCMState] }),
    // withNgxsPreboot(()=>({}))
  ],
  ngxsConfig: {
    // developmentMode: false,
    // selectorOptions: {
    //   suppressErrors: false,
    // },
    // compatibility: {
    //   strictContentSecurityPolicy: true,
    // },
    // Execution strategy overridden for illustrative purposes
    // (only do this if you know what you are doing)
    // executionStrategy: NoopNgxsExecutionStrategy,
  },
  defaultLocaleID: 'hu-HU',
  ngrxDevTools: {},
};
